import { Toggle } from 'components/Common/Toggle';
import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { Col, Label, Row } from 'reactstrap';
import { HelpText } from 'components/HelpText';

import { DualCountryListSelector } from 'components/Common/DualCountryListSelector';

export const OrderTypeEditCountry = () => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  const toggleCheckbox = field => {
    formik.setFieldValue(field, !formik.values[field]);
  };

  return (
    <>
      {/* Enable Country - Main Toggle */}
      <Row className="d-flex mt-3 flex-wrap align-items-center py-2 border-bottom">
        <Col xs={12} xl={4} className="p-0">
          <Label className="m-0 fw-semibold">
            {t('orderTypes.enableCountry')}
            <HelpText size="sm" noBackground hideIcon>
              Enable country selection for this order type
            </HelpText>
          </Label>
        </Col>
        <Col xs={12} xl={8} className="p-0 d-flex align-items-center">
          <Toggle
            checked={formik.values.enableCountry}
            onChange={() => toggleCheckbox('enableCountry')}
            label=""
          />
        </Col>
      </Row>

      {/* Conditional Fields */}
      {formik.values.enableCountry && (
        <>
          {/* Available For Countries */}
          <Row className="d-flex mt-3 flex-wrap align-items-start py-2">
            <Col xs={12} xl={4} className="p-0">
              <Label className="m-0 fw-semibold">
                {t('orderTypes.availableForCountries')}
                <HelpText size="sm" noBackground hideIcon>
                  Select which countries this order type is available for
                </HelpText>
              </Label>
            </Col>
            <Col xs={12} xl={8} className="p-0">
              <DualCountryListSelector
                selected={formik.values.availableForCountries}
                onChange={newValue => {
                  formik.setFieldValue('availableForCountries', newValue);
                }}
              />
            </Col>
          </Row>

          {/* Enable Visa Type */}
          <Row className="d-flex mt-3 flex-wrap align-items-center py-2 border-top">
            <Col xs={12} xl={4} className="p-0">
              <Label className="m-0 fw-semibold">
                {t('orderTypes.enableVisaType')}
                <HelpText size="sm" noBackground hideIcon>
                  Enable visa type selection
                </HelpText>
              </Label>
            </Col>
            <Col xs={12} xl={8} className="p-0 d-flex align-items-center">
              <Toggle
                checked={formik.values.enableVisaType}
                onChange={() => toggleCheckbox('enableVisaType')}
                label=""
              />
            </Col>
          </Row>

          {/* Enable Granted Visa */}
          <Row className="d-flex mt-3 flex-wrap align-items-center py-2">
            <Col xs={12} xl={4} className="p-0">
              <Label className="m-0 fw-semibold">
                {t('orderTypes.enableGrantedVisa')}
                <HelpText size="sm" noBackground hideIcon>
                  {t('orderTypes.enableGrantedVisaDescription')}
                </HelpText>
              </Label>
            </Col>
            <Col xs={12} xl={8} className="p-0 d-flex align-items-center">
              <Toggle
                checked={formik.values.enableGrantedVisa}
                onChange={() => toggleCheckbox('enableGrantedVisa')}
                label=""
              />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};
